import { gql } from '@apollo/client';

export const patientOrdersDisplayLabels = gql`
  query PatientOrdersDisplayLabels(
    $externalId: String
    $encounterIdentifier: AkidoIdentifierArg
  ) {
    getFhirEncounter(
      externalId: $externalId
      encounterIdentifier: $encounterIdentifier
    ) {
      orders {
        list {
          displayLabel
        }
      }
    }
  }
`;
